exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification-list.component .body {\n  margin-bottom: 7px !important;\n}\n\n.notification-list.component .body ul {\n   width: 100%;\n}\n\n.notification-list.component .notification-stack-item.component {\n  flex: 1;\n  box-sizing: border-box;\n  opacity: 1.0;\n  width: auto;\n  box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.0);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/notification/list.css
// module id = 771
// module chunks = 0